export const getEasing = (props) => props.theme.easing;
//# sourceMappingURL=getEasing.js.map